import { render, staticRenderFns } from "./income.vue?vue&type=template&id=41c998e0&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c998e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c998e0')) {
      api.createRecord('41c998e0', component.options)
    } else {
      api.reload('41c998e0', component.options)
    }
    module.hot.accept("./income.vue?vue&type=template&id=41c998e0&scoped=true", function () {
      api.rerender('41c998e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/setup/cate/income.vue"
export default component.exports